"use client"
import "./HomeContainer.css";
import { React, useState } from "react";
import NavigationBar from "@/components/NavigationBar/NavigationBar";
import ReviewContainer from "@/components/ReviewContainer/ReviewContainer";
import ReviewFilter from "@/components/ReviewFilter/ReviewFilter";

/**
 * @file This file provides the HomeContainer component. It is the main container for the home page.
 * @description This component is responsible for rendering the home page layout and managing the state of the home page.
 * @requires React, useState, useEffect
 * @returns {JSX.Element} The HomeContainer component.
 * @see ../components/HomeContainer/HomeContainer.js
 */
export default function HomeContainer() {
  // State to hold the filter criteria
  const [filterCriteria, setFilterCriteria] = useState({
    orderCriteria: "updateTime",
    orderDirection: "desc",
    searchTerm: "",
  });

  return (
    <div className="homeContainer">
      <NavigationBar/>
      <ReviewFilter
        globalFilterCriteria={filterCriteria}
        setGlobalFilterCriteria={setFilterCriteria}
      />
      <ReviewContainer 
        filters={filterCriteria}
      />
    </div>
  )
}